// shadcn/ui Label (new-york), vendored.
// GEN-183 — every input has a label JOINED to it: this Radix Label wires
// htmlFor/id so clicking the label focuses the control, and the fields the
// screens draw without a visible label carry an aria-label instead (the
// filter selects, the cell inputs) — a name a screen reader gets either way.
import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 text-sm font-medium leading-none peer-disabled:pointer-events-none peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
